import { render, staticRenderFns } from "./MultiRoleForm.vue?vue&type=template&id=3c869972"
import script from "./MultiRoleForm.vue?vue&type=script&lang=js"
export * from "./MultiRoleForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports